// Selector "Modo de margen" del formulario de bot PRIVADO -- mismo campo
// (`margin_mode`) y mismas opciones/aviso que el wizard público (ConfigStep):
// Aislado recomendado; Cruzado con aviso de calibración.
// WP-wizard-exchange-modos (docs/specs/Spec_Wizard_Exchange_Modos.md §2.3).
export default function MarginModeField({ value, onChange }) {
  return (
    <div>
      <label htmlFor="bot-margin-mode" className="block text-sm text-slate-500 dark:text-gray-400 mb-1.5">
        Modo de margen
      </label>
      <select
        id="bot-margin-mode"
        value={value}
        onChange={e => onChange(e.target.value)}
        className="input"
      >
        <option value="isolated">Aislado (recomendado — calibración del estudio)</option>
        <option value="cross">Cruzado</option>
      </select>
      {value === 'cross' && (
        <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-1.5">
          ⚠ Te desvías de la calibración del estudio (liquidación modelada con margen aislado).
        </p>
      )}
    </div>
  )
}
